<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :required="true"
              :label="$t('MSG_TXT_SRCH_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-date-picker
              ref="datePicker"
              v-model="singleDatetime"
              :disabled="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PORTL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-custom-select
              ref="portalId"
              :selected="searchBox.portalId"
              :option-list="selectPortalList"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MENU_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="searchBox.menuName"
              @keyup="onKeyUpInput"
              @keyup.enter="onSearch('button')"
            />
            <!-- <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="onPopupClick"
            /> -->
            <!-- <cmp-user-select :selectedUser="searchBox.pageId" /> -->
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_USR')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-user-select
              ref="userSelect"
              :selectedUser="selectedUser"
              @selected="onSelectedUser"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset "
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsSystemUseLog'"
        :hideHeader="false"
        :autoheight="false"
        :multiselect="false"
        :pageable="false"
        :initialPagesize="10"
        :showDisplayCountControl="false"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="this.$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onDownloadExcel"
          >
            {{ $t("MSG_BTN_EXCEL_DOWN") }}
          </sui-button>
        </div>
      </sui-grid>
      <div class="btn_moreView">
        <p
          :class="pageing.totalCount === 0 || pageing.count === pageing.totalCount ? 'disabled' : ''"
          @click="onAddList"
        >
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMP_00013', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      isPageing: false,
      pageing: {
        pagePerCount: 5000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },

      // searchBox datePicker
      singleDatetime: moment().format('YYYY-MM-DD'),

      // searchBox userInfo
      selectedUser: {
        userName: '',
        epid: '',
      },
      
      // searchBox portalOptionList
      selectPortalList: [],

      // 더보기 SearchBox
      showMoreSearchBox: {},

      // Search Box
      searchBox: {
        menuLogDTM: '',
        pageId: '',
        pageName: '',
        menuName: '',
        menuLogUserId: '',
        portalId: {
          key: '',
          label: '',
        },
      },
      searchFieldOldText: '',

      localdata0: [],

      gridColumns0: [{
        text: this.$t('MSG_TXT_PORTL'),
        datafield: 'portalId',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_TYPE'),
        datafield: 'menuLogTypeName',
        width: 120,
      }, {
        text: this.$t('MSG_TXT_MENU_NM'),
        datafield: 'menuName',
      }, {
        text: this.$t('MSG_TXT_USR'),
        datafield: 'menuLogUserId',
        width: 300,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '2', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              userId: 'finalModificationUserId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsSystemUseLog, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_APPLICATION_NM'),
        datafield: 'applicationName',
        width: 200,
      }, {
        text: this.$t('MSG_TXT_MENU_RESO_ID'),
        datafield: 'menuResoId',
        width: 180,
      }, {
        text: this.$t('MSG_TXT_LOG_DTM'),
        datafield: 'firstRegistrationDTM',
        width: 180,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dsSystemUseLog, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      }],

      localdata1: [], // excel
      excelGridColumns: [
        {
          text: this.$t('MSG_TXT_PORTL'),
          datafield: 'portalId',
          width: 120,
        }, {
          text: this.$t('MSG_TXT_TYPE'),
          datafield: 'menuLogTypeName',
          width: 120,
        }, {
          text: this.$t('MSG_TXT_MENU_NM'),
          datafield: 'menuName',
        // }, {
        //   text: this.$t('MSG_TXT_USR_ID'),
        //   datafield: 'knoxId',
        //   width: 400,
        // }, {
        //   text: this.$t('MSG_TXT_DEPT'),
        //   datafield: 'departmentName',
        //   width: 400,
        }, {
          text: this.$t('MSG_TXT_USR'),
          datafield: 'userName',
          width: 400,
        }, {
          text: this.$t('MSG_TXT_APPLICATION_NM'),
          datafield: 'applicationName',
        }, {
          text: this.$t('MSG_TXT_MENU_RESO_ID'),
          datafield: 'menuResoId',
          width: 200,
        }, {
          text: this.$t('MSG_TXT_LOG_DTM'),
          datafield: 'firstRegistrationDTM',
          width: 150,
          cellsrenderer: (r, c, v, h, p) => utils.dateCellRenderer(r, c, v, h, p),
        },
      ],
    };
  },
  datasets: [{
    id: 'dsSystemUseLog',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'portalId',
      type: 'string',
      map: 'portalId',
    }, {
      name: 'menuLogTypeCode',
      type: 'string',
      map: 'menuLogTypeCode',
    }, {
      name: 'menuLogTypeName',
      type: 'string',
      map: 'menuLogTypeName',
    }, {
      name: 'menuLogObjectId',
      type: 'string',
      map: 'menuLogObjectId',
    }, {
      name: 'menuLogDepartmentId',
      type: 'string',
      map: 'menuLogDepartmentId',
    }, {
      name: 'menuLogDepartmentName',
      type: 'string',
      map: 'menuLogDepartmentName',
    }, {
      name: 'menuLogUserId',
      type: 'string',
      map: 'menuLogUserId',
    }, {
      name: 'menuName',
      type: 'string',
      map: 'menuName',
    }, {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    }, {
      name: 'loginId',
      type: 'string',
      map: 'loginId',
    }, {
      name: 'knoxId',
      type: 'string',
      map: 'knoxId',
    }, {
      name: 'applicationName',
      type: 'string',
      map: 'applicationName',
    }, {
      name: 'menuResoId',
      type: 'string',
      map: 'menuResoId',
    }, {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    }],
  }, {
    id: 'dsExcel',
    type: 'local',
    data: 'localdata1',
    datafields: [
      { type: 'string', name: 'menuLogHistoryUid', map: 'menuLogHistoryUid' },
      { type: 'string', name: 'menuLogTypeCode', map: 'menuLogTypeCode' },
      { type: 'string', name: 'menuLogTypeName', map: 'menuLogTypeName' },
      { type: 'string', name: 'menuLogObjectId', map: 'menuLogObjectId' },
      { type: 'string', name: 'menuLogDepartmentId', map: 'menuLogDepartmentId' },
      { type: 'string', name: 'menuLogDepartmentName', map: 'menuLogDepartmentName' },
      { type: 'string', name: 'menuLogUserId', map: 'menuLogUserId' },
      { type: 'string', name: 'pageName', map: 'pageName' },
      { type: 'string', name: 'pageId', map: 'pageId' },
      { type: 'string', name: 'menuLogDTM', map: 'menuLogDTM' },
      { type: 'string', name: 'menuName', map: 'menuName' },
      { type: 'string', name: 'finalModificationUserId', map: 'finalModificationUserId' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'applicationName', map: 'applicationName' },
      { type: 'string', name: 'menuResoId', map: 'menuResoId' },
      { type: 'string', name: 'softwareApplicationId', map: 'softwareApplicationId' },
      { type: 'string', name: 'portalId', map: 'portalId' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },

    ],
  }],
  computed: {
    showMoreCount() {
      return `(${this.pageing.count}/${this.pageing.totalCount})`;
    },
  },
  watch: {},
  mounted() {
        // portal list
    this.selectPortalList = [];
    http.request(this.$options.name, 'DTS_CMP_00004')
      .then(res => {
        utils.forEach(res.data, obj => {
          this.selectPortalList.push({
            key: obj.portalId,
            label: obj.portalName,
          });
        });
      })
      .catch(error => {
        console.log(error);
      });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onReset() {
      this.resetSearchBox();
    },
    onSearch() {
      if (this.validationCheck()) return false;
      // if (this.onClickValidate()) return false;

      this.pageing.currentPage = 1;
      this.pageing.totalCount = 0;
      this.pageing.count = 0;

      this.dsSystemUseLog.setRawData([]);

      this.setShowMoreSearchBox();
      this.searchSystemUseLogList();

      return true;
    },
    onSelectedUser(selectedData) {
      if (selectedData) {
        this.selectedUser.epid = selectedData.epId;
        this.selectedUser.userName = selectedData.userName;
      } else {
        this.selectedUser.epid = '';
        this.selectedUser.userName = '';

        // this.$refs.userSelect.reset();
      }
    },
    // onPopupClick() {
    //   utils.openLayerPopup('PGE_CMU_00004', this.onPagePopupCallback, {
    //     pageInitialData: {},
    //     size: 'lg',
    //   });
    // },
    // 결과 값
    // onPagePopupCallback(nodeData) {
    //   if (nodeData) {
    //     this.searchBox.pageId = nodeData[0].pageId;
    //     this.searchBox.pageName = nodeData[0].pageName;
    //   }
    // },
    onDownloadExcel() {
      if (this.dsExcel.data.length > 10000) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CNT_NOT_EXCEL_DOWN'), 10000));
        return;
      }


      const sPageId = this.$options.name;
      const objGridColumns = this.excelGridColumns;
      const objGridDataset = this.dsExcel;

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `menuLog_${sToday}.xlsx`;

      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName);
    },
    onAddList() {
      // 더보기
      if (this.isPageing) {
        this.pageing.currentPage += 1;
        this.searchSystemUseLogList();
      }
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    setDatePickerToSearchBox() {
      if (this.singleDatetime !== null && this.singleDatetime !== '') {
        const sMenuLogDTM = utils.dateformatToServer(this.singleDatetime);
        this.searchBox.menuLogDTM = sMenuLogDTM.substr(0, 8);
      }
    },
    setShowMoreSearchBox() {
      // datePicker 설정 값
      this.setDatePickerToSearchBox();

      // 사용자
      this.searchBox.menuLogUserId = this.selectedUser.epid;

      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      this.showMoreSearchBox = queryParams;
    },

    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });
      
      this.searchBox.portalId.key = this.selectPortalList[0].key;
      // datePicker 초기화
      this.singleDatetime = moment().format('YYYY-MM-DD');

      // 사용자 정보 리셋
      this.selectedUser.userName = '';
      this.selectedUser.epid = '';
      this.$refs.userSelect.reset();
    },
    searchSystemUseLogList() {
      const queryParams = utils.cloneDeep(this.showMoreSearchBox);

      // pageing
      utils.assign(queryParams, { pagePerCount: this.pageing.pagePerCount });
      utils.assign(queryParams, { currentPage: this.pageing.currentPage });

      http.request(this.$options.name, 'DTS_CMP_00037', {
        query: queryParams,
      }).then(res => {
        if (utils.isUndefined(res.data) === false && res.data.length === this.pageing.pagePerCount) {
          this.isPageing = true;
        } else {
          this.isPageing = false;
        }


        const union = utils.mergeArray(this.dsSystemUseLog.data, res.data);
        // excel
        // const dsExcel = utils.cloneDeep(res.data);
        this.dsExcel.setRawData(union);

        // main
        this.dsSystemUseLog.setRawData(union);

        this.pageing.count = this.dsSystemUseLog.data.length;
        if (res.data.length > 0) {
          this.pageing.totalCount = res.data[0].totalCount;
        }
        console.log(res);
      }).catch(error => {
        console.log(error);
      });
      return true;
    },
    validationCheck() {
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      if (utils.isEmpty(this.$refs.datePicker.value)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SRCH_DT')));
        return true;
      }
      return false;
    },
    // /* 달력의 오류를 확인할 수 있는 validate 함수 */
    // onClickValidate() {
    //   // if (this.onClickValidate()) return false;
    //   if (!this.$refs.datePicker.isValid()) {
    //     utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
    //     return true;
    //   }
    //   return false;
    // },
    onKeyUpInput() {
      // _ 제외 특수문자 입력제한
      const searchFieldNewText = this.searchBox.menuName;
      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.searchBox.menuName = this.searchFieldOldText;
        });
      } else {
        this.searchFieldOldText = searchFieldNewText;
      }
    },
  },
};
</script>
<style scoped>
</style>
